<template>
  <div>
    <div class="row">
      <div class="col-12">
        <SectionTitle content="Información General" :has-line="true" />
      </div>
    </div>
    <div class="row mb-5 pl-3">
      <div class="col-2 py-0">
        <label>Seleccione la fecha:</label>
        <CustomDatePicker
          :value="model.evalDiscussionDate"
          :disabled="readonly"
          @onSelectedDate="onDateChanged"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { SectionTitle } from '@/components/pei/shared';

import CustomDatePicker from '@/components/common/CustomDatePicker';
export default {
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isValid: false,
      page: {
        icon: 'fas fa-user-edit',
        title: 'Discusión de la Evaluación',
        routes: [
          'Inicio',
          'PEI',
          'Referidos de Asistencia Tecnológica',
          'Estatus: Pendiente de Discusión',
          'Discusión de la Evaluación',
        ],
      },
    };
  },
  components: {
    CustomDatePicker,
    SectionTitle,
  },
  methods: {
    validate() {
      this.isValid = !!this.model.evalDiscussionDate;
      this.$emit('changed', 1, this.isValid);

      return this.isValid;
    },
    onDateChanged(date) {
      if (date) {
        this.model.evalDiscussionDate = date;
      }
      this.validate();
    },
  },
  mounted() {
    this.validate();
  },
};
</script>
